<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__slcustomer}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.broker" placeholder="经纪人姓名" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.mechanismName" filterable clearable placeholder="合作机构">
            <el-option v-for="item in mechanismNames" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.brokerType" filterable clearable placeholder="类型">
            <el-option v-for="item in userTypes" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-date-picker v-model="dateValue" type="daterange" :picker-options="pickerOptions" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" @change="getTimes" value-format="yyyy-MM-dd" align="right">
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-input v-model="dataForm.userName" placeholder="借款人姓名" clearable></el-input>
        </el-form-item>

        <el-form-item>
          <el-select v-model="dataForm.status" filterable clearable placeholder="进件状态">
            <el-option v-for="item in statusList2" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-select v-model="dataForm.productCode" filterable clearable placeholder="产品名称">
            <el-option v-for="item in productNameList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button @click="getDataList()">{{ $t("query") }}</el-button>
        </el-form-item>

        <!-- <el-form-item>
          <el-button @click="getDaoList()" type="primar">导出</el-button>
         
        </el-form-item> -->
        <!-- exportHandle() -->
        <el-form-item>
          <el-button type="primary" @click="getDaoList()">{{ $t('export') }}</el-button>
          <dev style="font-size: 12px;margin-left: 6px;color: #d58b46;">提示: 单次导出最多支持3个月</dev>
        </el-form-item>
        <!-- <el-form-item>
          <el-button v-if="$hasPermission('sys:slcustomer:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:slcustomer:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item> -->
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border style="width: 100%">
        <!-- <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column> -->
        <el-table-column prop="id" label="进件ID/申请ID" header-align="center" align="center"></el-table-column>
        <el-table-column v-if="$hasPermission('wx:entry:broker')" prop="broker" label="经纪人" header-align="center"
          align="center"></el-table-column>
        <el-table-column v-if="$hasPermission('wx:entry:Mobile')" prop="brokerMobile" label="手机号" header-align="center"
          align="center"></el-table-column>
        <el-table-column prop="brokerType" label="类型" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- <el-select v-if="scope.row.myishsow" v-model="scope.row.brokerType"  filterable clearable  placeholder="类型">
                  <el-option
                          v-for="item in userTypes"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                  </el-option>
            </el-select>
            <div v-else>{{ geteducation(scope.row.brokerType,'userType') }}</div> -->
            {{ geteducation(scope.row.brokerType, "userType") }}
          </template>
        </el-table-column>
        <el-table-column prop="mechanism" label="合作机构" header-align="center" align="center"></el-table-column>
        <el-table-column prop="productName" label="产品名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="borrowerInformation" width="200" label="借款人信息" header-align="center" align="center">
          <template slot-scope="scope">
            <span v-html="getText(scope.row.borrowerInformation)"></span>
          </template>
        </el-table-column>
        <el-table-column prop="createDate" label="进件时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="productAmount" label="最高额度(万)" header-align="center" align="center">
          <!-- <template slot-scope="scope">
            <el-input v-if="scope.row.myishsow" v-model="scope.row.loanAmount" placeholder="请输入" clearable></el-input>
            <div v-else>{{ scope.row.loanAmount }}</div>
          </template> -->
        </el-table-column>
        <el-table-column prop="status" min-width="200" label="进件状态" header-align="center" align="center">
          <template slot-scope="scope">
            <el-select v-if="scope.row.myishsow &&
              scope.row.status != '-1' &&
              scope.row.status != '7' &&
              scope.row.status != '6'
              " v-model="scope.row.status" filterable clearable placeholder="类型">
              <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <div v-else>{{ geteducation(scope.row.status, "status") }}</div>
          </template>
        </el-table-column>

        <el-table-column prop="realAmount" min-width="200" label="核额金额(元)" header-align="center" align="center">
          <template slot-scope="scope">
            <el-input v-if="scope.row.myishsow" v-model="scope.row.realAmount" placeholder="请输入" clearable></el-input>
            <div v-else>{{ scope.row.realAmount }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="efficientAmount" label="生效额度" header-align="center" align="center"></el-table-column>
        <el-table-column prop="realTime" label="核额时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="applyTime" label="FI申请时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="applyNo" label="FI申请编号" header-align="center" align="center"></el-table-column>

        <el-table-column prop="loanAmount" min-width="200" label="放款金额(元)" header-align="center" align="center">
          <template slot-scope="scope">
            <el-input v-if="scope.row.myishsow" v-model="scope.row.loanAmount" placeholder="请输入" clearable></el-input>
            <div v-else>{{ scope.row.loanAmount }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="loanTime" label="放款时间" header-align="center" align="center"></el-table-column>

        <el-table-column prop="yrymCaptainCode" label="团队长邀请码" header-align="center" align="center"></el-table-column>

        <el-table-column prop="remark" label="备注" min-width="200" header-align="center" align="center">
          <template slot-scope="scope">
            <el-input v-if="scope.row.myishsow" v-model="scope.row.remark" placeholder="请输入" clearable></el-input>
            <div v-else>{{ scope.row.remark }}</div>
          </template>
        </el-table-column>

        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <!-- scope.row.status != '-1' && (!scope.row.applyNo || scope.row.productCode != '1654399399442964481') ) -->
            <el-button v-if="!scope.row.applyNo && $hasPermission('wx:entry:ok1')" type="text" size="small"
              @click="submitStatus(scope.row)">{{ scope.row.myishsow ? "完成" : "修改" }}</el-button>
            <el-button v-if="ifTrue(scope.row) && $hasPermission('wx:entry:ok2')" type="danger" size="small"
              @click="submitStatus(scope.row, 2)">{{ scope.row.myishsow ? "完成" : "审核不通过" }}</el-button>
            <!-- <el-button v-if="$hasPermission('sys:slcustomer:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">完成</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page="page" :page-sizes="[10, 20, 50, 100]" :page-size="limit" :total="total"
        layout="total, sizes, prev, pager, next, jumper" @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <!-- <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update> -->
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from "@/mixins/view-module";
import { getList, pageList } from "@/api/list";
// import AddOrUpdate from './entry-add-or-update'
export default {
  mixins: [mixinViewModule],
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/sys/inputmanagement/page",
        getDataListIsPage: true,
        // exportURL: "/sys/slproducttender/export",
        exportURL: "/sys/inputmanagement/export",
        deleteURL: "/sys/slproducttender",
        deleteIsBatch: true,
      },
      text: "修改",
      userTypes: [],
      statusList: [],
      statusList2: [],
      mechanismNames: [],
      productNameList: [],
      dataForm: {
        status: "",
        id: "",
        userType: "",
        productCode: "",
        startDate: "",
        endDate: "",
      },
      dateValue: '',
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit("pick", [start, end]);
            },
          },

          {
            text: "昨天",
            onClick(picker) {
              console.log(picker);
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              end.setTime(end.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "过去七天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上周",
            onClick(picker) {
              // 上周开始时间
              const starta = new Date();
              var first = starta.getDate() - starta.getDay() - 6;
              var startDate = new Date(starta.setDate(first));
              const start = new Date(startDate);
              start.setHours(0, 0, 0, 0);
              //  上周结束时间
              var currentDate = new Date();
              var firsts = currentDate.getDate() - currentDate.getDay() - 6;
              var last = firsts + 6;
              var endDate = new Date(currentDate.setDate(last));
              const end = new Date(endDate);
              end.setHours(23, 59, 59, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              var end = new Date();
              var week = end.getDay();
              console.log(week, "week");
              //一天的毫秒数
              var millisecond = 1000 * 60 * 60 * 24;
              //减去的天数
              var minusDay = week != 0 ? week - 1 : 6;

              //本周 周一
              var monday = new Date(end.getTime() - minusDay * millisecond);
              const start = new Date(monday);
              start.setHours(0, 0, 0, 0);
              console.log("2312", start, end);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  created() {
    this.getuserTypeOptions();
    this.getentryStatusOptions();
    getList("/sys/inputmanagement/mechanism").then(({ data: res }) => {
      console.log(res.data);
      this.mechanismNames = res.data.map((item) => {
        return { value: item.name, label: item.name };
      });
      // this.mechanismNames
    });
    pageList("/sys/inputmanagement/slproduct").then(({ data: res }) => {
      console.log(res.data.list);
      this.productNameList = res.data.list.map((item) => {
        return { value: item.id, label: item.productName };
      });
      // this.mechanismNames
    });
  },

  methods: {
    //导出的条件限制
    getDaoList() {
      if ((this.dateValue[0] === undefined) && (this.dateValue[1] === undefined)) {
        this.$message('请选择你所选导出日期范围');

        return
      }
      console.log(this.dateValue[0], 'ooooooooooooooo', this.dateValue[1]);
      const date1 = new Date(this.dateValue[0]);
      const date2 = new Date(this.dateValue[1]);
      const oneDay = 24 * 60 * 60 * 1000; // 一天的毫秒数
      const diffDays = Math.round(Math.abs((date2 - date1) / oneDay));

      console.log(diffDays); // 输出结果为 2
      if (!(diffDays < 94)) {
        this.$message('所选导出日期范围必须在3个月内');

        return
      } else {
        this.$message('正在导出');
        this.exportHandle()

      }


    },
    getTimes() {
      if (this.dateValue != null) {
        this.dataForm.startDate = this.dateValue[0] + ' 00：00：00';
        this.dataForm.endDate = this.dateValue[1] + ' 23：59：59';
      } else {
        this.dataForm.startDate = "";
        this.dataForm.endDate = "";
      }
    },
    ///sys/mechanism/list
    getText(v) {
      if (v) {
        return `姓名: ${JSON.parse(v)["姓名"]}<br/>手机号: ${JSON.parse(v)["手机号"]
          }`;
      }
    },
    ifTrue(row) {
      if (row.applyNo) {
        return false;
      } else {
        if (row.status != "-1" && row.status != "7") {
          return true;
        }
        return false;
      }
    },

    //修改状态
    submitStatus(row, num) {
      console.log(this.dataList.findIndex((item) => item.id == row.id));
      let n = this.dataList.findIndex((item) => item.id == row.id);
      this.$set(this.dataList, n, {
        ...this.dataList[n],
        myishsow: !this.dataList[n].myishsow,
      });
      if (row.myishsow) {
        let obj = {
          id: row.id,
          remark: row.remark,
          status: row.status,
          realAmount: row.realAmount,
          loanAmount: row.loanAmount,
        };
        if (num) {
          this.$http
            .put(`sys/slproducttender/${row.id}?failureReason=${row.remark}`)
            .then(({ data: res }) => {
              if (res.code !== 0) {
                this.query();
                return this.$message.error(res.msg);
              }
              this.$message.success(res.msg);
              this.query();
            });
          return;
        }
        this.$http.put("/sys/slproducttender", obj).then(({ data: res }) => {
          if (res.code !== 0) {
            this.query();
            return this.$message.error(res.msg);
          }
          this.$message.success(res.msg);
          this.query();
        });
      }
    },
    geteducation(v, name) {
      if (name == "userType")
        return this.userTypes.filter((item) => item.value == v)[0]?.label;
      // if(name == 'education') return this.educations.filter(item => item.value == v)[0]?.label ;
      // if(name == 'vipLevelId') return this.vipLevels.filter(item => item.value == v)[0]?.label ;
      // if(name == 'maritalStatus') return this.maritalStatus.filter(item => item.value == v)[0]?.label ;
      // if(name == 'isAuth') return this.isAuth.filter(item => item.value == v)[0]?.label ;
      // if(v == '-1'){
      //   return '审核未通过'
      // }
      // if(v == '7'){
      //   return '失效'
      // }
      // if(v == '6'){
      //   return '未在本机构完成申请'
      // }
      if (name == "status")
        return this.statusList2.filter((item) => item.value == v)[0]?.label;
    },
    //初始用户类型名称下拉框中的选项
    async getuserTypeOptions() {
      this.$http
        .get(`/sys/dict/data/list?dataType=userType`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.userTypes = [];
          if (res.data != null) {
            res.data.forEach((element) => {
              this.userTypes.push({
                label: element.dictLabel,
                value: element.dictValue,
              });
            });
          }
        })
        .catch(() => { });
    },
    //初始进件状态下拉框中的选项
    async getentryStatusOptions() {
      this.$http
        .get(`/sys/dict/data/list?dataType=entryStatus`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.statusList = [];
          this.statusList2 = [];
          if (res.data != null) {
            res.data.forEach((element) => {
              this.statusList.push({
                label: element.dictLabel,
                value: element.dictValue,
              });
              this.statusList2.push({
                label: element.dictLabel,
                value: element.dictValue,
              });
            });
            // {label: '未在本机构完成申请', value: '6'}
            this.statusList2.push(
              { label: "审核未通过", value: "-1" },
              { label: "失效", value: "7" }
            );
            console.log(this.statusList2);
          }
        })
        .catch(() => { });
    },
  },
  components: {
    // AddOrUpdate
  },
};
</script>
